import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import FaqAnswer from '../../../shared/FaqAnswer'
import Question from './Question'

const QuestionItem = ({ question, marked, onClick }) => {
  const collapsed = useMemo(() => marked !== question.key, [marked, question])

  return (
    <div
      className={`select-none border-t-2 border-gray-200 py-2 lg:px-4 lg:py-3 ${
        !marked ? 'hover:bg-gray-130' : ''
      }`}
    >
      <Question collapsed={collapsed} question={question} onClick={onClick} />
      <FaqAnswer
        collapsed={collapsed}
        content={question.answer}
        className="whitespace-pre-line px-1 text-gray-400"
      />
    </div>
  )
}

QuestionItem.defaultProps = {
  marked: null,
}
QuestionItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  marked: PropTypes.string,
  question: PropTypes.object.isRequired,
}

export default React.memo(QuestionItem)
